import BackgroundEffect from '../components/BackgroundEffect';
const PrivacyPolicy = () => {
    const styles = {
        container: {
            maxWidth: "950px",
            margin: "50px auto",
            padding: "50px",
            background: "linear-gradient(180deg, #ffffff 0%, #f5f8fa 100%)",
            borderRadius: "16px",
            boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
            fontFamily: "'Segoe UI', Roboto, sans-serif",
            color: "#003e64",
            lineHeight: "1.8",
            transition: "all 0.3s ease-in-out",
        },
        title: {
            fontSize: "2.6rem",
            fontWeight: "700",
            marginBottom: "10px",
            textAlign: "center",
            color: "#003e64",
            letterSpacing: "0.5px",
        },
        subtitle: {
            textAlign: "center",
            marginBottom: "35px",
            color: "#374651",
            fontSize: "1rem",
            backgroundColor: "#fdf3eb",
            padding: "15px",
            borderRadius: "10px",
            border: "1px solid #e87115",
        },
        section: {
            marginBottom: "35px",
            paddingBottom: "25px",
            borderBottom: "1px solid #e1e5e9",
        },
        sectionTitle: {
            fontSize: "1.3rem",
            fontWeight: "700",
            marginBottom: "12px",
            color: "#e87115",
            textTransform: "uppercase",
            letterSpacing: "0.6px",
        },
        list: {
            marginLeft: "25px",
            paddingLeft: "10px",
            listStyleType: "disc",
        },
        listItem: {
            marginBottom: "6px",
            fontSize: "1.2rem",
        },
        paragraph: {
            fontSize: "1.2rem",
            color: "#003e64",
            marginBottom: "12px",
        },
        footer: {
            borderTop: "2px solid #e87115",
            marginTop: "40px",
            paddingTop: "25px",
            fontSize: "0.95rem",
            textAlign: "center",
            color: "#003e64",
            fontWeight: "600",
            letterSpacing: "0.4px",
        },
        contact: {
            marginTop: "15px",
            lineHeight: "1.6",
        },
        link: {
            color: "#e87115",
            textDecoration: "none",
            fontWeight: "600",
        },
        linkHover: {
            textDecoration: "underline",
        },
    };

    return (
        <div style={styles.container}>
            <BackgroundEffect />
            <h1 style={styles.title}>Privacy Policy</h1>
            <p style={styles.subtitle}>
                <strong>Effective Date:</strong> 2nd September 2025 <br />
                <strong>Company:</strong> JSKM Technologies Private Limited <br />
                <strong>Website:</strong>{" "}
                <a
                    href="https://www.jskmtechnologies.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.link}
                >
                    https://www.jskmtechnologies.com
                </a>
                <br />
                <strong>Email:</strong>{" "}
                <a href="mailto:contact@jskmtechnologies.com" style={styles.link}>
                    contact@jskmtechnologies.com
                </a>
                <br />
                <strong>Phone:</strong> +91 96763 62000
            </p>

            {/* Section 1 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>1. Introduction</h2>
                <p style={styles.paragraph}>
                    <b>JSKM Technologies Private Limited</b> (“Company,” “we,” “our,” or “us”) respects your privacy and is committed to protecting your personal information.<br />
                    This Privacy Policy explains how we collect, use, store, disclose, and protect your information when you use our website, applications (including <b>TrustMee</b>), or services across IT, HR, medical, and trade sectors.
                    By accessing our website or using our services, you agree to this Privacy Policy.
                </p>
            </div>

            {/* Section 2 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>2. Information We Collect</h2>
                <p style={styles.paragraph}>We collect the following categories of information:</p>

                <h3>2.1. Information You Provide to Us</h3>
                <p style={styles.paragraph}>When you interact with our services, you may provide:</p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>
                        <strong>Personal Information:</strong> Name, email, phone number, address, company name, designation, etc.
                    </li>
                    <li style={styles.listItem}>
                        <strong>Business Information:</strong> Service requirements, project details, billing data.
                    </li>
                    <li style={styles.listItem}>
                        <strong>Account Information:</strong> Login credentials (if applicable, e.g., for TrustMee).
                    </li>
                    <li style={styles.listItem}>
                        <strong>Payment Details:</strong> Only necessary transaction information; we do not store full card or banking data.
                    </li>
                </ul>

                <h3>2.2. Information Collected Automatically</h3>
                <p style={styles.paragraph}>When you visit our website or apps, we automatically collect:</p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>IP address, browser type, and operating system.</li>
                    <li style={styles.listItem}>Pages visited, time spent, and referral source.</li>
                    <li style={styles.listItem}>Device information and general location (city/country level).</li>
                    <li style={styles.listItem}>Cookies and similar tracking technologies (see Section 9).</li>
                </ul>

                <h3>2.3. Information from Third Parties</h3>
                <p style={styles.paragraph}>We may receive information from:</p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>Business partners, clients, or service providers (for HR or export operations).</li>
                    <li style={styles.listItem}>App stores or authentication platforms (e.g., for TrustMee app users).</li>
                    <li style={styles.listItem}>Publicly available databases or marketing platforms, where permitted by law.</li>
                </ul>
            </div>


            {/* Section 3 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>3. How We Use Your Information</h2>
                <p style={styles.paragraph}>We use collected information for legitimate business purposes, including:</p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>To deliver and improve our IT, HR, medical, and trade services.</li>
                    <li style={styles.listItem}>To communicate with clients, partners, and users.</li>
                    <li style={styles.listItem}>To process payments and manage invoices.</li>
                    <li style={styles.listItem}>To maintain security and prevent fraudulent activity.</li>
                    <li style={styles.listItem}>To comply with legal or regulatory obligations.</li>
                    <li style={styles.listItem}>To personalize and enhance the user experience.</li>
                </ul>
                <p style={styles.paragraph}>We do <b>not</b> sell, rent, or lease personal information to third parties.</p>
            </div>

            {/* Section 4 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>4. Data Sharing and Disclosure</h2>
                <p style={styles.paragraph}>We may share information only in the following situations:</p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>
                        <strong>Service Providers:</strong> With trusted third-party vendors who assist in operations (e.g., payment gateways, hosting providers, courier/logistics partners).
                    </li>
                    <li style={styles.listItem}>
                        <strong>Legal Requirements:</strong> When required by law, court order, or regulatory authorities.
                    </li>
                    <li style={styles.listItem}>
                        <strong>Business Transfers:</strong> In case of merger, acquisition, or restructuring, information may be transferred under confidentiality obligations.
                    </li>
                    <li style={styles.listItem}>
                        <strong>Client Collaboration:</strong> For HR, coding, or export projects where business data sharing is necessary for fulfillment.
                    </li>
                </ul>
                <p style={styles.paragraph}>All third parties handling data on our behalf are bound by confidentiality and data protection obligations.</p>
            </div>

            {/* Section 5 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>5. Data Retention</h2>
                <p style={styles.paragraph}>
                    We retain personal data only for as long as necessary:
                </p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>To fulfill the purposes outlined in this policy;</li>
                    <li style={styles.listItem}>To comply with legal and accounting requirements;</li>
                    <li style={styles.listItem}>Or until you request deletion, subject to applicable law.</li>
                </ul>
                <p style={styles.paragraph}>Once data is no longer required, it is securely deleted or anonymized.</p>
            </div>

            {/* Section 7 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>6. Data Security</h2>
                <p style={styles.paragraph}>
                    We use advanced administrative, technical, and physical safeguards to protect your data from unauthorized access, alteration, disclosure, or destruction.<br />Security measures include:
                </p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>Secure servers and encrypted communication (HTTPS, SSL).</li>
                    <li style={styles.listItem}>Limited access to authorized personnel.</li>
                    <li style={styles.listItem}>Regular system audits and backups.</li>
                </ul>
                <p style={styles.paragraph}>However, no internet transmission is completely secure, and you acknowledge that you share information at your own risk.</p>
            </div>

            {/* Section 7 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>7. Your Rights</h2>
                <p style={styles.paragraph}>
                    Depending on your jurisdiction, you may have the following rights regarding your personal information:
                </p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>Access and obtain a copy of your data.</li>
                    <li style={styles.listItem}>Request correction or deletion of inaccurate information.</li>
                    <li style={styles.listItem}>Withdraw consent (where applicable).</li>
                    <li style={styles.listItem}>Object to or restrict processing of your data.</li>
                </ul>
                <p style={styles.paragraph}>To exercise these rights, contact us at <a href="mailto:contact@jskmtechnologies.com" style={styles.link}>
                    contact@jskmtechnologies.com
                </a><br />
                    We will respond within a reasonable time frame in compliance with applicable data protection laws..</p>
            </div>

            {/* Section 8 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>8. International Data Transfers</h2>
                <p style={styles.paragraph}>
                    We operate globally, and your data may be processed or stored on servers located outside your country.<br />
                    By using our services, you consent to such transfers, which are safeguarded by industry-standard protection measures.
                </p>
            </div>

            {/* Section 9 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>9. Cookies and Tracking Technologies</h2>
                <p style={styles.paragraph}>
                    Our website and apps use cookies and similar technologies to enhance user experience.<br />
                    Cookies help us:
                </p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>Remember user preferences;</li>
                    <li style={styles.listItem}>Analyze website performance;</li>
                    <li style={styles.listItem}>Deliver relevant ads or marketing messages.</li>
                </ul>
                <p style={styles.paragraph}>
                    You can manage or disable cookies through your browser settings.<br />
                    For more information, please refer to our <b>Cookies Policy.</b>
                </p>
            </div>

            {/* Section 10 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>10. Children’s Privacy</h2>
                <p style={styles.paragraph}>
                    Our services are not directed toward individuals under 18 years of age.<br />
                    We do not knowingly collect personal data from minors.<br />
                    If we become aware that we have unintentionally collected data from a child, we will delete it promptly.
                </p>
            </div>

            {/* Section 11 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>11. Links to Other Websites</h2>
                <p style={styles.paragraph}>
                    Our website or applications may contain links to third-party websites.<br />
                    We are not responsible for the privacy practices or content of those external sites.<br />
                    We encourage you to review their privacy policies separately.
                </p>
            </div>

            {/* Section 12 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>12. Changes to This Privacy Policy</h2>
                <p style={styles.paragraph}>
                    We may update this Privacy Policy periodically to reflect business, legal, or regulatory changes.<br />
                    Revisions will be posted on our website with an updated <b>Effective Date.</b><br />
                    We encourage you to review this page regularly.
                </p>
            </div>

            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>13. Contact Us</h2>
                <p style={styles.paragraph}>For questions, requests, or concerns about this Privacy Policy, please contact:</p>
                <p style={styles.contact}>
                    <b>JSKM Technologies Private Limited</b> <br />
                    📧 <b>Email:</b>{" "}
                    <a href="mailto:contact@jskmtechnologies.com" style={styles.link}>
                        contact@jskmtechnologies.com
                    </a>{" "}
                    <br />
                    📞 <b>Phone:</b> +91 96763 62000 <br />
                    🌐 <b>Website:</b>{" "}
                    <a
                        href="https://www.jskmtechnologies.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={styles.link}
                    >
                        https://www.jskmtechnologies.com
                    </a>
                </p>
            </div>
        </div>
    );
};

export default PrivacyPolicy;